/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderFlagDTOFromJSON, OrderFlagDTOToJSON, } from './OrderFlagDTO';
import { PurchaserInfoResponseDTOFromJSON, PurchaserInfoResponseDTOToJSON, } from './PurchaserInfoResponseDTO';
import { OrderWarehouseInfoDTOFromJSON, OrderWarehouseInfoDTOToJSON, } from './OrderWarehouseInfoDTO';
import { OrderItemResponseDTOFromJSON, OrderItemResponseDTOToJSON, } from './OrderItemResponseDTO';
import { OrderProfitabilityDTOFromJSON, OrderProfitabilityDTOToJSON, } from './OrderProfitabilityDTO';
/**
 * @export
 */
export const OrderResponseDTOOrderStatusEnum = {
    PendingAvailability: 'PENDING_AVAILABILITY',
    Pending: 'PENDING',
    Unshipped: 'UNSHIPPED',
    PartiallyShipped: 'PARTIALLY_SHIPPED',
    Shipped: 'SHIPPED',
    InvoiceUnconfirmed: 'INVOICE_UNCONFIRMED',
    Cancelled: 'CANCELLED',
    Unfulfillable: 'UNFULFILLABLE'
};
/**
 * @export
 */
export const OrderResponseDTOPackageStatusEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * Check if a given object implements the OrderResponseDTO interface.
 */
export function instanceOfOrderResponseDTO(value) {
    return true;
}
export function OrderResponseDTOFromJSON(json) {
    return OrderResponseDTOFromJSONTyped(json, false);
}
export function OrderResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'amazonOrderId': json['amazonOrderId'] == null ? undefined : json['amazonOrderId'],
        'buyerOrderId': json['buyerOrderId'] == null ? undefined : json['buyerOrderId'],
        'purchaseDate': json['purchaseDate'] == null ? undefined : (new Date(json['purchaseDate'])),
        'lastUpdateDate': json['lastUpdateDate'] == null ? undefined : (new Date(json['lastUpdateDate'])),
        'shipByDate': json['shipByDate'] == null ? undefined : (new Date(json['shipByDate'])),
        'deliverByDate': json['deliverByDate'] == null ? undefined : (new Date(json['deliverByDate'])),
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'cancelledBy': json['cancelledBy'] == null ? undefined : json['cancelledBy'],
        'cancellationRequestedBy': json['cancellationRequestedBy'] == null ? undefined : json['cancellationRequestedBy'],
        'cancellationReason': json['cancellationReason'] == null ? undefined : json['cancellationReason'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'orderTotalAmount': json['orderTotalAmount'] == null ? undefined : json['orderTotalAmount'],
        'purchaserInfo': json['purchaserInfo'] == null ? undefined : PurchaserInfoResponseDTOFromJSON(json['purchaserInfo']),
        'orderItems': json['orderItems'] == null ? undefined : (json['orderItems'].map(OrderItemResponseDTOFromJSON)),
        'packageStatus': json['packageStatus'] == null ? undefined : json['packageStatus'],
        'warehouseInfo': json['warehouseInfo'] == null ? undefined : OrderWarehouseInfoDTOFromJSON(json['warehouseInfo']),
        'profitability': json['profitability'] == null ? undefined : OrderProfitabilityDTOFromJSON(json['profitability']),
        'note': json['note'] == null ? undefined : json['note'],
        'noteUpdatedAt': json['noteUpdatedAt'] == null ? undefined : (new Date(json['noteUpdatedAt'])),
        'flag': json['flag'] == null ? undefined : OrderFlagDTOFromJSON(json['flag']),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
    };
}
export function OrderResponseDTOToJSON(json) {
    return OrderResponseDTOToJSONTyped(json, false);
}
export function OrderResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'amazonOrderId': value['amazonOrderId'],
        'buyerOrderId': value['buyerOrderId'],
        'purchaseDate': value['purchaseDate'] == null ? undefined : ((value['purchaseDate']).toISOString()),
        'lastUpdateDate': value['lastUpdateDate'] == null ? undefined : ((value['lastUpdateDate']).toISOString()),
        'shipByDate': value['shipByDate'] == null ? undefined : ((value['shipByDate']).toISOString()),
        'deliverByDate': value['deliverByDate'] == null ? undefined : ((value['deliverByDate']).toISOString()),
        'orderStatus': value['orderStatus'],
        'cancelledBy': value['cancelledBy'],
        'cancellationRequestedBy': value['cancellationRequestedBy'],
        'cancellationReason': value['cancellationReason'],
        'marketplace': value['marketplace'],
        'currencyCode': value['currencyCode'],
        'orderTotalAmount': value['orderTotalAmount'],
        'purchaserInfo': PurchaserInfoResponseDTOToJSON(value['purchaserInfo']),
        'orderItems': value['orderItems'] == null ? undefined : (value['orderItems'].map(OrderItemResponseDTOToJSON)),
        'packageStatus': value['packageStatus'],
        'warehouseInfo': OrderWarehouseInfoDTOToJSON(value['warehouseInfo']),
        'profitability': OrderProfitabilityDTOToJSON(value['profitability']),
        'note': value['note'],
        'noteUpdatedAt': value['noteUpdatedAt'] == null ? undefined : ((value['noteUpdatedAt']).toISOString()),
        'flag': OrderFlagDTOToJSON(value['flag']),
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
    };
}
